import { useMantineTheme } from "@mantine/core";

export const useColors = () => useMantineTheme().other.colors;
